/**
 * The currently known {@link PaperFormat}s
 */
export enum PaperFormatName {
	"4A" = "4A",
	"2A" = "2A",
	"A0" = "A0",
	"A1" = "A1",
	"A2" = "A2",
	"A3" = "A3",
	"A4" = "A4",
	"A5" = "A5",
	"A6" = "A6",
	"A7" = "A7",
	"A8" = "A8",
	"A9" = "A9",
	"A10" = "A10",
	"4B" = "4B",
	"2B" = "2B",
	"B0" = "B0",
	"B1" = "B1",
	"B2" = "B2",
	"B3" = "B3",
	"B4" = "B4",
	"B5" = "B5",
	"B6" = "B6",
	"B7" = "B7",
	"B8" = "B8",
	"B9" = "B9",
	"B10" = "B10",
	"C0" = "C0",
	"C1" = "C1",
	"C2" = "C2",
	"C3" = "C3",
	"C4" = "C4",
	"DL" = "DL",
	"C5" = "C5",
	"C6" = "C6",
	"C7/6" = "C7/6",
	"C7" = "C7",
	"C8" = "C8",
	"C9" = "C9",
	"C10" = "C10",
	"Large Post" = "Large Post",
	"Letter" = "Letter",
	"Legal" = "Legal",
	"Ledger" = "Ledger",
	"Tabloid" = "Tabloid",
	"ANSI A (letter)" = "ANSI A (letter)",
	"ANSI B (ledger)" = "ANSI B (ledger)",
	"ANSI B (tabloid)" = "ANSI B (tabloid)",
	"ANSI C" = "ANSI C",
	"ANSI D" = "ANSI D",
	"ANSI E" = "ANSI E",
	"ANSI F', " = "ANSI F', ",
	"Statement Half Letter" = "Statement Half Letter",
	"Quarto" = "Quarto",
	"Foolscap (folio)" = "Foolscap (folio)",
	"Super-B" = "Super-B",
	"Post" = "Post",
	"Crown" = "Crown",
	"Demy" = "Demy",
	"Medium (us)" = "Medium (us)",
	"Broadsheet" = "Broadsheet",
	"Royal" = "Royal",
	"Elephant" = "Elephant",
	"Double Demy" = "Double Demy",
	"Quad Demy" = "Quad Demy",
	"JB0" = "JB0",
	"JB1" = "JB1",
	"JB2" = "JB2",
	"JB3" = "JB3",
	"JB4" = "JB4",
	"JB5" = "JB5",
	"JB6" = "JB6",
	"JB7" = "JB7",
	"JB8" = "JB8",
	"JB9" = "JB9",
	"JB10" = "JB10",
	"JB11" = "JB11",
	"JB12" = "JB12",
	"Shiroku ban 4" = "Shiroku ban 4",
	"Shiroku ban 5" = "Shiroku ban 5",
	"Shiroku ban 7" = "Shiroku ban 7",
	"Kiku 4" = "Kiku 4",
	"Kiku 5" = "Kiku 5",
	"Emperor" = "Emperor",
	"Antiquarian" = "Antiquarian",
	"Grand Eagle" = "Grand Eagle",
	"Double Elephant" = "Double Elephant",
	"Atlas" = "Atlas",
	"Colombier" = "Colombier",
	"Imperial" = "Imperial",
	"Double Large Post" = "Double Large Post",
	"Princess" = "Princess",
	"Cartridge" = "Cartridge",
	"Sheet Half Post" = "Sheet Half Post",
	"Double Post" = "Double Post",
	"Super Royal" = "Super Royal",
	"Medium (jp)" = "Medium (jp)",
	"Copy Draught" = "Copy Draught",
	"Pinched Post" = "Pinched Post",
	"Foolscap" = "Foolscap",
	"Small Foolscap" = "Small Foolscap",
	"Brief" = "Brief",
	"Pott" = "Pott",
}

/**
 * All known paper sizes as {@link PaperFormatGroup}s
 */
export const paperSizes: Array<PaperFormatGroup> = [
	{
		name: "a", values: [
			{name: PaperFormatName["4A"], width: 1682, height: 2378},
			{name: PaperFormatName["2A"], width: 1189, height: 1682},
			{name: PaperFormatName["A0"], width: 841, height: 1189},
			{name: PaperFormatName["A1"], width: 594, height: 841},
			{name: PaperFormatName["A2"], width: 420, height: 594},
			{name: PaperFormatName["A3"], width: 297, height: 420},
			{name: PaperFormatName["A4"], width: 210, height: 297},
			{name: PaperFormatName["A5"], width: 148, height: 210},
			{name: PaperFormatName["A6"], width: 105, height: 148},
			{name: PaperFormatName["A7"], width: 74, height: 105},
			{name: PaperFormatName["A8"], width: 52, height: 74},
			{name: PaperFormatName["A9"], width: 37, height: 52},
			{name: PaperFormatName["A10"], width: 26, height: 37}
		]
	},
	{
		name: "b", values: [
			{name: PaperFormatName["4B"], width: 2000, height: 2828},
			{name: PaperFormatName["2B"], width: 1414, height: 2000},
			{name: PaperFormatName["B0"], width: 1000, height: 1414},
			{name: PaperFormatName["B1"], width: 707, height: 1000},
			{name: PaperFormatName["B2"], width: 500, height: 707},
			{name: PaperFormatName["B3"], width: 353, height: 500},
			{name: PaperFormatName["B4"], width: 250, height: 353},
			{name: PaperFormatName["B5"], width: 176, height: 250},
			{name: PaperFormatName["B6"], width: 125, height: 176},
			{name: PaperFormatName["B7"], width: 88, height: 125},
			{name: PaperFormatName["B8"], width: 62, height: 88},
			{name: PaperFormatName["B9"], width: 44, height: 62},
			{name: PaperFormatName["B10"], width: 31, height: 44}
		]
	},
	{
		name: "c", values: [
			{name: PaperFormatName["C0"], width: 917, height: 1297},
			{name: PaperFormatName["C1"], width: 648, height: 917},
			{name: PaperFormatName["C2"], width: 458, height: 648},
			{name: PaperFormatName["C3"], width: 324, height: 458},
			{name: PaperFormatName["C4"], width: 229, height: 324},
			{name: PaperFormatName["DL"], width: 220, height: 110},
			{name: PaperFormatName["C5"], width: 162, height: 229},
			{name: PaperFormatName["C6"], width: 114, height: 162},
			{name: PaperFormatName["C7/6"], width: 81, height: 162},
			{name: PaperFormatName["C7"], width: 81, height: 114},
			{name: PaperFormatName["C8"], width: 57, height: 81},
			{name: PaperFormatName["C9"], width: 40, height: 57},
			{name: PaperFormatName["C10"], width: 28, height: 40}
		]
	},
	{
		name: "american", values: [
			{name: PaperFormatName["Large Post"], width: 419, height: 533},
			{name: PaperFormatName["Letter"], width: 216, height: 279},
			{name: PaperFormatName["Legal"], width: 216, height: 356},
			{name: PaperFormatName["Ledger"], width: 432, height: 279},
			{name: PaperFormatName["Tabloid"], width: 279, height: 432},
			{name: PaperFormatName["ANSI A (letter)"], width: 216, height: 279},
			{name: PaperFormatName["ANSI B (ledger)"], width: 432, height: 279},
			{name: PaperFormatName["ANSI B (tabloid)"], width: 279, height: 432},
			{name: PaperFormatName["ANSI C"], width: 432, height: 559},
			{name: PaperFormatName["ANSI D"], width: 559, height: 864},
			{name: PaperFormatName["ANSI E"], width: 864, height: 1118},
			{name: PaperFormatName["ANSI F', "], width: 2, height: 1016},
			{name: PaperFormatName["Statement Half Letter"], width: 140, height: 216},
			{name: PaperFormatName["Quarto"], width: 203, height: 254},
			{name: PaperFormatName["Foolscap (folio)"], width: 210, height: 330},
			{name: PaperFormatName["Super-B"], width: 330, height: 483},
			{name: PaperFormatName["Post"], width: 394, height: 489},
			{name: PaperFormatName["Crown"], width: 381, height: 508},
			{name: PaperFormatName["Demy"], width: 445, height: 572},
			{name: PaperFormatName["Medium (us)"], width: 457, height: 584},
			{name: PaperFormatName["Broadsheet"], width: 457, height: 610},
			{name: PaperFormatName["Royal"], width: 508, height: 635},
			{name: PaperFormatName["Elephant"], width: 584, height: 711},
			{name: PaperFormatName["Double Demy"], width: 572, height: 889},
			{name: PaperFormatName["Quad Demy"], width: 889, height: 1143}
		]
	},
	{
		name: "japanese", values: [
			{name: PaperFormatName["JB0"], width: 1030, height: 1456},
			{name: PaperFormatName["JB1"], width: 728, height: 1030},
			{name: PaperFormatName["JB2"], width: 515, height: 728},
			{name: PaperFormatName["JB3"], width: 364, height: 515},
			{name: PaperFormatName["JB4"], width: 257, height: 364},
			{name: PaperFormatName["JB5"], width: 182, height: 257},
			{name: PaperFormatName["JB6"], width: 128, height: 182},
			{name: PaperFormatName["JB7"], width: 91, height: 128},
			{name: PaperFormatName["JB8"], width: 64, height: 91},
			{name: PaperFormatName["JB9"], width: 45, height: 64},
			{name: PaperFormatName["JB10"], width: 32, height: 45},
			{name: PaperFormatName["JB11"], width: 22, height: 32},
			{name: PaperFormatName["JB12"], width: 16, height: 22},
			{name: PaperFormatName["Shiroku ban 4"], width: 264, height: 379},
			{name: PaperFormatName["Shiroku ban 5"], width: 189, height: 262},
			{name: PaperFormatName["Shiroku ban 7"], width: 127, height: 188},
			{name: PaperFormatName["Kiku 4"], width: 227, height: 306},
			{name: PaperFormatName["Kiku 5"], width: 151, height: 227}
		]
	},
	{
		name: "inch", values: [
			{name: PaperFormatName["Emperor"], width: 1219, height: 1829},
			{name: PaperFormatName["Antiquarian"], width: 787, height: 1346},
			{name: PaperFormatName["Grand Eagle"], width: 730, height: 1067},
			{name: PaperFormatName["Double Elephant"], width: 678, height: 1016},
			{name: PaperFormatName["Atlas"], width: 660, height: 864},
			{name: PaperFormatName["Colombier"], width: 597, height: 876},
			{name: PaperFormatName["Imperial"], width: 559, height: 762},
			{name: PaperFormatName["Double Large Post"], width: 533, height: 838},
			{name: PaperFormatName["Princess"], width: 546, height: 711},
			{name: PaperFormatName["Cartridge"], width: 533, height: 660},
			{name: PaperFormatName["Sheet Half Post"], width: 495, height: 597},
			{name: PaperFormatName["Double Post"], width: 483, height: 762},
			{name: PaperFormatName["Super Royal"], width: 483, height: 686},
			{name: PaperFormatName["Medium (jp)"], width: 470, height: 584},
			{name: PaperFormatName["Copy Draught"], width: 406, height: 508},
			{name: PaperFormatName["Pinched Post"], width: 375, height: 470},
			{name: PaperFormatName["Foolscap"], width: 343, height: 432},
			{name: PaperFormatName["Small Foolscap"], width: 337, height: 419},
			{name: PaperFormatName["Brief"], width: 343, height: 406},
			{name: PaperFormatName["Pott"], width: 318, height: 381}
		]
	}
];

/**
 * Interface for a group of {@link PaperFormat}s
 */
export interface PaperFormatGroup {
	name: string;
	values: Array<PaperFormat>;
}

/**
 * Interface for a PaperFormat
 */
export interface PaperFormat {
	name: PaperFormatName;
	width: number;
	height: number;
}

/**
 * The PaperHelper bundles useful static functions for paper formats
 */
export default abstract class PaperHelper {
	/**
	 * Find a specific {@link PaperFormat} by {@link PaperFormatName}
	 */
	public static findFormat(name: PaperFormatName): PaperFormat | null {
		for (let formatGroup of paperSizes) {
			for (let paperFormat of formatGroup.values) {
				if (paperFormat.name === name) {
					return paperFormat;
				}
			}
		}

		return null;
	}
}